






















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class AuditHistoryDetailDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Object, default: null }) auditHistory: any;

  dialog = false;

  @Watch("value")
  onValueChange(newVal: boolean) {
    this.dialog = newVal;
  }

  @Watch("dialog")
  onDialogChange(newVal: boolean) {
    this.$emit("input", newVal);
  }

  close() {
    this.dialog = false;
  }

  formatDate(dateString: string) {
    if (!dateString) {
      return "";
    }
    return new Date(dateString).toLocaleString();
  }

  formatJson(jsonString: string) {
    if (!jsonString) {
      return "";
    }
    try {
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch {
      return jsonString;
    }
  }
}
